var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorPredictionTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 23,
    viewBox: "0 0 382 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_519_2852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3 18C12.76 19.73 11.17 20.51 9.14 20.51C4.82 20.51 2.03 16.83 2.03 11.13C2.03 5.43 4.81 1.84 9.27 1.84C10.97 1.84 12.46 2.53 13.69 3.9L13.88 4.11L15.08 2.78L14.94 2.61C14.26 1.83 12.37 0 9.27 0C3.64 0 0 4.37 0 11.13C0 17.89 3.65 22.35 9.08 22.35C11.67 22.35 13.72 21.37 15.54 19.26L15.69 19.09L14.49 17.8L14.31 18.01L14.3 18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.41 0C23.05 0 19.46 4.46 19.46 11.1C19.46 17.74 23.06 22.36 28.41 22.36C33.76 22.36 37.33 17.84 37.33 11.1C37.33 4.36 33.75 0 28.41 0ZM28.41 20.51C24.21 20.51 21.49 16.81 21.49 11.1C21.49 5.39 24.21 1.84 28.41 1.84C32.61 1.84 35.3 5.47 35.3 11.09C35.3 16.71 32.53 20.5 28.41 20.5V20.51Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.84 0.379883H43.87V21.9699H55.54V20.1899H45.84V0.379883Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.93 0C62.57 0 58.98 4.46 58.98 11.1C58.98 17.74 62.58 22.36 67.93 22.36C73.28 22.36 76.85 17.84 76.85 11.1C76.85 4.36 73.27 0 67.93 0ZM67.93 20.51C63.73 20.51 61.01 16.81 61.01 11.1C61.01 5.39 63.73 1.85 67.93 1.85C72.13 1.85 74.82 5.48 74.82 11.1C74.82 16.72 72.05 20.51 67.93 20.51Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.85 6.19988C96.85 2.33988 94.43 0.379883 89.66 0.379883H83.39V21.9699H85.36V12.2699H89.45L95.15 21.9699H97.43L91.6 12.1199C94.95 11.5399 96.85 9.39988 96.85 6.19988ZM85.36 2.12988H89.27C93.15 2.12988 94.81 3.34988 94.81 6.19988C94.81 9.04988 92.95 10.5599 89.27 10.5599H85.36V2.12988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.26 0.379883H112.25V21.9699H114.22V12.9099H118.26C123.25 12.9099 126 10.6399 126 6.51988C126 2.39988 123.54 0.379883 118.26 0.379883ZM114.23 2.12988H117.88C122.34 2.12988 124 3.31988 124 6.51988C124 9.71988 122.17 11.1699 117.88 11.1699H114.23V2.12988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.75 6.19988C145.75 2.33988 143.33 0.379883 138.56 0.379883H132.29V21.9699H134.26V12.2699H138.35L144.05 21.9699H146.33L140.5 12.1199C143.85 11.5399 145.75 9.39988 145.75 6.19988ZM134.26 2.12988H138.17C142.05 2.12988 143.71 3.34988 143.71 6.19988C143.71 9.04988 141.85 10.5599 138.17 10.5599H134.26V2.12988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.35 11.4099H162.8V9.62988H154.35V2.15988H164.4V0.379883H152.38V21.9699H164.72V20.1899H154.35V11.4099Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.12 0.379883H171.01V21.9699H176.16C182.4 21.9699 185.98 18.0099 185.98 11.0999C185.98 4.18988 182.48 0.389883 176.13 0.389883L176.12 0.379883ZM172.98 2.12988H175.96C181.1 2.12988 183.93 5.30988 183.93 11.0999C183.93 16.8899 181.1 20.2199 175.96 20.2199H172.98V2.12988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.54 0.379883H192.57V21.9699H194.54V0.379883Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.36 18C213.82 19.73 212.23 20.51 210.2 20.51C205.88 20.51 203.09 16.83 203.09 11.13C203.09 5.43 205.86 1.84 210.33 1.84C212.03 1.84 213.52 2.53 214.75 3.9L214.94 4.11L216.14 2.78L216 2.61C215.32 1.83 213.42 0 210.33 0C204.7 0 201.06 4.37 201.06 11.13C201.06 17.89 204.71 22.35 210.14 22.35C212.73 22.35 214.78 21.37 216.6 19.26L216.75 19.09L215.55 17.8L215.37 18.01L215.36 18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.81 2.15988H226.52V21.9699H228.5V2.15988H235.18V0.379883H219.81V2.15988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.9 0.379883H240.93V21.9699H242.9V0.379883Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.36 0C253 0 249.41 4.46 249.41 11.1C249.41 17.74 253.01 22.36 258.36 22.36C263.71 22.36 267.28 17.84 267.28 11.1C267.28 4.36 263.69 0 258.36 0ZM258.36 20.51C254.16 20.51 251.44 16.81 251.44 11.1C251.44 5.39 254.16 1.85 258.36 1.85C262.56 1.85 265.25 5.48 265.25 11.1C265.25 16.72 262.48 20.51 258.36 20.51Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.56 13.5599C286.56 15.3499 286.63 17.1599 286.72 18.9199L284.69 15.3799L275.75 0.379883H273.82V21.9699H275.7V8.62988C275.7 6.84988 275.63 5.16988 275.55 3.42988L277.58 6.96988L286.52 21.9699H288.45V0.379883H286.57V13.5599H286.56Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.94 2.15988H309.66V21.9699H311.63V2.15988H318.32V0.379883H302.94V2.15988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.97 0C325.61 0 322.02 4.46 322.02 11.1C322.02 17.74 325.62 22.36 330.97 22.36C336.32 22.36 339.89 17.84 339.89 11.1C339.89 4.36 336.3 0 330.97 0ZM330.97 20.51C326.77 20.51 324.05 16.81 324.05 11.1C324.05 5.39 326.77 1.85 330.97 1.85C335.17 1.85 337.86 5.48 337.86 11.1C337.86 16.72 335.09 20.51 330.97 20.51Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.01 0C348.65 0 345.06 4.46 345.06 11.1C345.06 17.74 348.66 22.36 354.01 22.36C359.36 22.36 362.93 17.84 362.93 11.1C362.93 4.36 359.34 0 354.01 0ZM354.01 20.51C349.81 20.51 347.09 16.81 347.09 11.1C347.09 5.39 349.81 1.85 354.01 1.85C358.21 1.85 360.9 5.48 360.9 11.1C360.9 16.72 358.13 20.51 354.01 20.51Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.44 20.1899V0.379883H369.47V21.9699H381.13V20.1899H371.44Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_519_2852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 381.13,
    height: 22.35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPredictionTool);
export default __webpack_public_path__ + "static/media/colorPredictionTool.c64a076dff70daba5f5fec45f3763b7f.svg";
export { ForwardRef as ReactComponent };